/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes'

export default StyleSheet.create({
  container: {
    flex: 1,
    flexDirection:'row',
    justifyContent: 'space-between',
    height: 44,
    borderColor:'#d3d3d3',
    borderStyle: 'solid',
    borderWidth : 1,
    padding: 12
  },

  image : {
    width: 30 , height: 30
  },
  marginRight : {
    marginRight: 0
  },
  textStyle : {
    fontSize: 14,
    marginLeft: 10,
    fontSize: 15,
    color: Fonts.style.color.baseColor,
    fontFamily:Fonts.style.font.regular,
  }
})
